import React, { useState, useEffect, useContext, useRef } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdAndTravelType, showAlert } from "../../Services/Shared.service";
import { createPackage, createPackageRate, editPackageDetails, editPackageRateDetails, getPackageRate, getPackagesList, getTaxGroupList, createPackageRateSchedule, updatePackageRateSchedule, getPackageRateSchedules } from "../../Services/Packages.service";
import { useRateConstraints, validatePerKmCharge } from "../../hooks/useRateConstraints";
import moment from "moment";
import {  addMinutes, addSeconds, startOfToday } from "date-fns";
import CustomizerContext from "../../_helper/Customizer";
import { Box, Typography, Drawer} from "@mui/material";
import closeIcon from "../../assets/images/tarrifManagement/closeIcon.svg";
import PackageRateScheduleTable from "./PackageRateScheduleTable";

const EditPackageRateForm = ({ editId, isOpen,setIsOpen,packagesData,fetchTableData }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset
    } = useForm({
        defaultValues: {
            package: "",
            minPkgDistance: "",
            pkgDistance: "",
            pkgTimeInMin: "",
            pkgCharge: "",
            addnlPerKmCharge: "",
            addnlTimeCharge: "",
            addnlTimeChargeBlockInMin: "",
            isTaxInclusive: false,
            timeFrom: "",
            timeTo: "",
            isTimeBased: false,
            maxPkgDistance: "",
            packageValue: "",
            isNightfareTimeSlot: false,
            // packageRideType: "",
            effectiveFrom: new Date()
        },
    });
    const values = getValues()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [editingFromChild, setEditingFromChild] = useState(false)

    const { mix_background_layout } = useContext(CustomizerContext)
    const [packageRateObj, setPackageRateObj] = useState({})
    const rewardConstraints = useRateConstraints();
    const getMinutes = (date) => {
        if (!date) return null;
        return date.getHours() * 60 + date.getMinutes();
    };
    const isTaxInclusiveField = useController({
        name: "isTaxInclusive",
        control,
    }).field;

    const isTimeBasedField = useController({
        name: "isTimeBased",
        control,
    }).field;

    const isNightfareTimeSlotField = useController({
        name: "isNightfareTimeSlot",
        control,
    }).field;

    const packageField = useController({
        name: "package",
        control,
        rules: {
            required: {
                value: true,
                message: "Package is Required",
            },
        },
    }).field;

    const handlePackageField = (data) => {
        packageField.onChange(data.value)
    }

    // const packageRideTypeField = useController({
    //     name: "packageRideType",
    //     control,
    //     rules: {
    //         required: {
    //             value: true,
    //             message: "Package Ride Type is Required",
    //         },
    //     },
    // }).field;

    // const handlePackageRideTypeSelectChange = (data) => {
    //     packageRideTypeField.onChange(data.value);
    // };
    
    const effectiveFromField = useController({
        name: "effectiveFrom",
        control,
    }).field;

    const addnlTimeChargeBlockInMinField = useController({
        name: "addnlTimeChargeBlockInMin",
        control,
        rules: {
            required: {
                value: true,
                message: "Extra Time Block (in hours) is Required",
            },
        },
    }).field;

    const handleAddnlTimeChargeBlockInMin = (data) => {
        addnlTimeChargeBlockInMinField.onChange(data);
    };

    const pkgTimeInMinField = useController({
        name: "pkgTimeInMin",
        control,
        rules: {
            required: {
                value: true,
                message: "Package Hours is Required",
            },
        },
    }).field;

    const handlePkgTimeInMinDate = (data) => {
        pkgTimeInMinField.onChange(data);
    };

    const timeFromField = useController({
        name: "timeFrom",
        control,
        rules: {
            required: {
                value: isTimeBasedField.value ? true : false,
                message: "Applicable From is Required",
            },
        },
    }).field;

    const handleTimeFrom = (data) => {
        timeFromField.onChange(data);
    };

    const timeToField = useController({
      name: "timeTo",
      control,
      rules: {
        required: {
          value: isTimeBasedField.value,
          message: "Time To is Required",
        },
        validate: (value) => {
          if (!isTimeBasedField.value) return true;

          const from = getMinutes(timeFromField.value);
          const to = getMinutes(value);

          const isFromMidnight =
            timeFromField.value?.getHours() === 0 &&
            timeFromField.value?.getMinutes() === 0;

          const isToMidnight =
            value?.getHours() === 0 && value?.getMinutes() === 0;

          // Allow the special case: 12 AM → 12 AM
          if (isFromMidnight && isToMidnight) {
            return true;
          }

          // Allow ANY time → 12 AM (To)
          if (isToMidnight && !isFromMidnight) {
            return true;
          }

          // If either is null, skip (required checks this)
          if (from == null || to == null) return true;

          // Normal rule: To > From
          if (to <= from) {
            return "End time should be greater than start time";
          }

          return true;
        },
      },
    }).field;

    function convertToSeconds(dateObj, isEndTime = false) {
      if (!dateObj) return null;

      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes();

      let sec = hours * 3600 + minutes * 60;

      // End time 12AM should be 86400
      if (isEndTime && sec === 0) sec = 86400;

      return sec;
    }


    const handleTimeTo = (data) => {
        timeToField.onChange(data);
    };

 


    const mapDataToForm = (data) => ({
        package: data.packagesId ? { id: data.packagesId, name: data.packagesName } : "",
        minPkgDistance: data.minPkgDistance || 0,
        pkgDistance: data.pkgDistance || 0,
        pkgTimeInMin: data.pkgTimeInMin ? Number(data.pkgTimeInMin) : 0,
        pkgCharge: data.pkgCharge || 0,
        addnlPerKmCharge: data.addnlPerKmCharge || 0,
        addnlTimeCharge: data.addnlTimeCharge || 0,
        addnlTimeChargeBlockInMin: data.addnlTimeChargeBlockInMin ? addMinutes(new Date().setHours(0, 0, 0, 0), Number(data.addnlTimeChargeBlockInMin)) : 0,
        isTaxInclusive: data.isTaxInclusive || false,
        timeFrom: data.timeFrom != null ? addSeconds(new Date().setHours(0, 0, 0, 0), data.timeFrom) : "",
        timeTo: data.timeTo != null ? addSeconds(new Date().setHours(0, 0, 0, 0), data.timeTo) : "",
        isTimeBased: data.isTimeBased || false,
        maxPkgDistance: data.maxPkgDistance || 0,
        packageValue: data.packageValue || 0,
        isNightfareTimeSlot: data.isNightfareTimeSlot || false,
        packageRideType: data.packageRideType || 0,
        effectiveFrom: new Date()
    });

    // Helper to preserve effective date when resetting
    const resetWithDate = (data, date) => {
        const formData = mapDataToForm(data);
        reset({ ...formData, effectiveFrom: date });
    };

    useEffect(() => {
        if (editId) {
            getPackageRate({ packageId: editId }).then((result) => {
                setPackageRateObj(result.data)
                // Initial load - reset normal
                reset(mapDataToForm(result.data));
            }).catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
        }
    }, [editId])
    
    // Watch Effective Date for Schedule Swapping
    const effectiveFromValue = useController({ name: "effectiveFrom", control }).field.value;
    const [editingScheduleId, setEditingScheduleId] = useState(null);
    const lastCheckedDateRef = useRef(null);

    useEffect(() => {
        const checkSchedule = async () => {
            if (!packageRateObj.id || !effectiveFromValue) return;

            const dateMoment = moment(effectiveFromValue);
            const dateString = dateMoment.format("YYYY-MM-DD");

            // Prevent infinite loop: Only proceed if date changed
            if (lastCheckedDateRef.current === dateString) return;

            // Only check if date is in the future
            if (dateMoment.startOf('day').isAfter(moment().startOf('day'))) {
                // Update ref only when we actually process a future date check
                lastCheckedDateRef.current = dateString;

                try {
                    const response = await getPackageRateSchedules(packageRateObj.id, {
                        status: "PENDING",
                        effectiveDateFrom: dateMoment.format("YYYY-MM-DD"),
                        effectiveDateTo: dateMoment.format("YYYY-MM-DD")
                    });

                    let existingSchedule = null;
                     if (response?.data?.list) {
                        existingSchedule = response.data.list.find(s => s.status === 'PENDING');
                    }

                    if (existingSchedule) {
                        setEditingScheduleId(existingSchedule.id);
                        // Swap data, but keep the date selected
                        // Ensure package info is preserved if missing in schedule
                        const scheduleValues = { ...existingSchedule };
                        if (!scheduleValues.packagesId && packageRateObj.packagesId) {
                            scheduleValues.packagesId = packageRateObj.packagesId;
                            scheduleValues.packagesName = packageRateObj.packagesName;
                        }
                        resetWithDate(scheduleValues, effectiveFromValue);
                        showAlert("success", `Loaded Upcoming Package Rate for ${dateMoment.format("DD-MM-YYYY")}`);
                    } else {
                        // User selected a future date with NO schedule.
                        // If we were previously editing a schedule, revert to base data.
                        if (editingScheduleId !== null) {
                            setEditingScheduleId(null);
                            resetWithDate(packageRateObj, effectiveFromValue);
                            showAlert("success", "Switched to creating new Upcoming Package Rate");
                        }
                    }
                } catch (err) {
                    console.error("Error checking schedule:", err);
                }
            } else {
                 lastCheckedDateRef.current = dateString;
                 // Date is today or past - revert to base data if we were editing a schedule
                 if (editingScheduleId !== null) {
                     setEditingScheduleId(null);
                     resetWithDate(packageRateObj, effectiveFromValue);
                 }
            }
        };
        checkSchedule();
    }, [effectiveFromValue, packageRateObj.id]);

    const rideTypeDatas = [
        { label: "All", value: "All" },
        { label: "AirportToCity", value: "AirportToCity" },
        { label: "CityToAirport", value: "CityToAirport" },
        { label: "CityToCity", value: "CityToCity" }
    ]

    const handleTime_To=(time,constraint)=>{
            let timeto= constraint=="S" ? Number(moment.duration(moment(time).format("HH:mm:ss")).asSeconds()) : Number(moment.duration(moment(time).format("HH:mm:ss")).asMinutes()); 
            if(timeto===0 && constraint=="S"){
                return 86400;
            }
            else if(timeto===0 && constraint=="M"){
                return 1440;
            }
            return timeto;
    }
    const [refreshSchedules, setRefreshSchedules] = useState(false);

    const onEditSubmit = async (formValues) => {
        setIsSubmitting(true)
        console.log("form values", formValues);
        const body = {
            id: packageRateObj.id,
            packagesId: Number(formValues.package.id),
            minPkgDistance: formValues.minPkgDistance ? Number(formValues.minPkgDistance) : 0,
            pkgDistance: formValues.pkgDistance ? Number(formValues.pkgDistance) : 0,
            pkgTimeInMin: Number(formValues.pkgTimeInMin) ?? 0,
            pkgCharge: formValues.pkgCharge ? Number(formValues.pkgCharge) : 0,
            addnlPerKmCharge: formValues.addnlPerKmCharge ? Number(formValues.addnlPerKmCharge) : 0,
            addnlTimeCharge: formValues.addnlTimeCharge ? Number(formValues.addnlTimeCharge) : 0,
            addnlTimeChargeBlockInMin: formValues.addnlTimeChargeBlockInMin ? Number(moment.duration(moment(formValues.addnlTimeChargeBlockInMin).format("HH:mm:ss")).asMinutes()) : 0,
            isTaxInclusive: formValues.isTaxInclusive ? true : false,
            timeFrom:formValues.isTimeBased && formValues.timeFrom ? Number(moment.duration(moment(formValues.timeFrom).format("HH:mm:ss")).asSeconds()) : 0,
            timeTo: formValues.isTimeBased && formValues.timeTo ? handleTime_To(formValues.timeTo,"S") : 86400,
            isTimeBased: formValues.isTimeBased ? true : false,
            maxPkgDistance: formValues.maxPkgDistance ? Number(formValues.maxPkgDistance) : 0,
            packageValue: formValues.packageValue ? Number(formValues.packageValue) : 0,
            isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
            packageRideType: formValues.packageRideType
        };

        const handleSuccess = async () => {
            fetchTableData();
            
            // Refresh packageRateObj from server to get latest data
            const result = await getPackageRate({ packageId: packageRateObj.id });
            setPackageRateObj(result.data);
            // Reset form to base package rate data with today's date
            resetWithDate(result.data, new Date());
            
            // Clear editing state
            setEditingScheduleId(null);
            lastCheckedDateRef.current = null;
            setRefreshSchedules(prev => !prev);
            setEditingFromChild(false);
            
            // Keep button disabled for extra 500ms to prevent accidental double-clicks
            setTimeout(() => setIsSubmitting(false), 500);
        }

        // Check Effective Date
        const effectiveDate = formValues.effectiveFrom ? moment(formValues.effectiveFrom) : moment();
        // Check if future date (ignoring time)
        const isFutureDate = formValues.effectiveFrom && effectiveDate.startOf('day').isAfter(moment().startOf('day'));

        if (isFutureDate) {
            console.log("Future Date");
            // Schedule Logic
            const scheduleBody = {
                packageRateId: packageRateObj.id,
                effectiveDate: effectiveDate.format("YYYY-MM-DD"),
                ...body
            };
            delete scheduleBody.id; // Remove ID for creation

            try {
                if (editingScheduleId) {
                     // Update existing schedule
                     await updatePackageRateSchedule(editingScheduleId, scheduleBody);
                     showAlert("success", "Upcoming Package Rate Updated successfully");
                     handleSuccess();
                } else {
                    // Create new
                    await createPackageRateSchedule(scheduleBody);
                    showAlert("success", `Upcoming Package Rate Created for ${effectiveDate.format("DD-MM-YYYY")}`);
                    handleSuccess();
                }
            } catch (err) {
                console.error(err);
                showAlert("error", err.response?.data?.message || "Failed to schedule rate change");
                setIsSubmitting(false);
            }
        } else {
            console.log("Base Rate");
             editPackageRateDetails(body)
            .then((result) => {
                showAlert("success", "Package Rate Details Updated Successfully");
                handleSuccess();
            })
            .catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
                setIsSubmitting(false)
            });
        }
    }

    const topRef = useRef(null); // Ref for scrolling to top

    const handleEditSchedule = (schedule) => {
        if (schedule?.effectiveDate) {
            // effectiveDate from API is likely YYYY-MM-DD string.
            // DatePicker expects a Date object.
            // moment(schedule.effectiveDate).toDate() handles string safely.
            const date = moment(schedule.effectiveDate).toDate();
            
            // Setting effectiveFrom triggers the useEffect to load schedule data
            setValue("effectiveFrom", date);
            setEditingFromChild(true);
            
            // Scroll to top of the drawer
            if (topRef.current) {
                topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }

    const handleClose = () => {
        setEditingFromChild(false);
        setIsOpen();
    };

    return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "45.67vw",
            borderTopLeftRadius: "1.49vw",
            borderBottomLeftRadius: "1.49vw",
          },
        }}
        sx={{
          "& .MuiDrawer-paper": {
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE & Edge
            "&::-webkit-scrollbar": {
              display: "none", // Chrome, Safari
            },
          },
        }}
      >
        <Box sx={{ flex: 1 }} ref={topRef}>
          <Box
            sx={{
              flex: 1,
              backgroundColor: "rgba(244, 247, 253, 1)",
              height: "3vw",
            }}
          >
            <Box
              sx={{
                paddingTop: "1vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "40%",
                gap: "1vw",
              }}
            >
              <img
                src={closeIcon}
                alt={"close"}
                style={{ width: "1.79vw", height: "1.79vw", cursor: "pointer" }}
                onClick={handleClose}
              />
              <Box
                sx={{
                  width: "0.78vw",
                  height: "0.78vw",
                  background: "rgba(57, 181, 74, 1)",
                  borderRadius: "30%",
                }}
              />
              <Typography
                sx={{
                  color: "rgba(57, 181, 74, 1)",
                  fontSize: "1.11vw",
                  fontWeight: "600",
                }}
              >
                Edit Package Rate
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              marginX: "1.04vw",
              marginTop: "0.69vw",
              paddingX: "0.69vw",
            }}
          >
            <Form onSubmit={handleSubmit(onEditSubmit)}>
              <Row style={{ display: "flex", justifyContent: "center" }}>
                {/* <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">Package</Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        isDisabled={true}
                        value={
                          packageField?.value?.id && packageField?.value?.name
                            ? { label: packageField.value.name, value: packageField.value }
                            : null
                        }
                        //   // defaultValue={cityData.find((element) => {
                        //   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   //   return element?.value?.id === cityField?.value?.id;
                        //   // })}

                        onChange={handlePackageField}
                        placeholder="Select Package"
                        options={packagesData || []}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.package?.message}
                    </span>
                  </Col>
                </FormGroup> */}
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Minimum Distance
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      maxLength={6}
                      {...register("minPkgDistance", {
                        required: {
                          value: true,
                          message: "Minimum Distance is required",
                        },
                        onChange: (e) => {
                          setValue(
                            "minPkgDistance",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.minPkgDistance?.message}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Maximum Distance
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      maxLength={6}
                      {...register("maxPkgDistance", {
                        required: {
                          value: true,
                          message: "Maximum Distance is required",
                        },
                        validate: (value) => {
                          const minDistance = getValues("minPkgDistance");
                          if (minDistance && value) {
                            const min = Number(minDistance);
                            const max = Number(value);
                            if (max <= min) {
                              return "Maximum Distance must be greater than Minimum Distance";
                            }
                          }
                          return true;
                        },
                        onChange: (e) => {
                          setValue(
                            "maxPkgDistance",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                          setValue(
                            "pkgDistance",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.maxPkgDistance?.message}
                    </span>
                  </Col>
                </FormGroup>
              </Row>
              <Row style={{ display: "flex", justifyContent: "center" }}>
                {/* <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Total Distance
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      {...register("pkgDistance", {
                        required: {
                          value: true,
                          message: "Total Distance is required",
                        },
                        onChange: (e) => {
                          setValue(
                            "pkgDistance",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.pkgDistance?.message}
                    </span>
                  </Col>
                </FormGroup> */}
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Package Fee
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      maxLength={7}
                      {...register("pkgCharge", {
                        required: {
                          value: true,
                          message: "Package Fee is required",
                        },
                        onChange: (e) => {
                          setValue(
                            "pkgCharge",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                          setValue(
                            "packageValue",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.pkgCharge?.message}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Per Km Charge
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      maxLength={6}
                      {...register("addnlPerKmCharge", {
                        required: {
                          value: true,
                          message: "Per Km Charge is required",
                        },
                        validate: (value) => validatePerKmCharge(value, rewardConstraints),
                        onChange: (e) => {
                          setValue(
                            "addnlPerKmCharge",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.addnlPerKmCharge?.message}
                    </span>
                  </Col>
                </FormGroup>
              </Row>
              <Row style={{ display: "flex", justifyContent: "left" }}>
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">Effective From</Label>
                  <Col lg="12">
                    <InputGroup className="date">
                      <DatePicker
                        className="form-control"
                        selected={effectiveFromField.value}
                        onChange={(date) => effectiveFromField.onChange(date)}
                        dateFormat="dd-MM-yyyy"
                        minDate={startOfToday()}
                        disabled={editingFromChild}
                        defaultValue={new Date()}
                        placeholderText="Select Date"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    </InputGroup>
                  </Col>
                </FormGroup>
                {/* <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Package Ride Type
                  </Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          packageRideTypeField?.value
                            ? rideTypeDatas.find((element) => {
                                return (
                                  element?.value === packageRideTypeField?.value
                                );
                              })
                            : ""
                        }
                        // defaultValue={cityData.find((element) => {
                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handlePackageRideTypeSelectChange}
                        placeholder="Select Package Ride Type"
                        options={rideTypeDatas}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.packageRideType?.message}
                    </span>
                  </Col>
                </FormGroup> */}
              </Row>

              <Row style={{ display: "flex", justifyContent: "center" }}>
                {isTimeBasedField.value ? (
                  <>
                    <FormGroup className="col-lg-6">
                      <Label className="col-lg-12 col-form-label">
                        Time From (Hours)
                      </Label>
                      <Col lg="12">
                        <InputGroup
                          className="date"
                          id="dt-minimum"
                          data-target-input="nearest"
                        >
                          <DatePicker
                            className="form-control datetimepicker-input digits"
                            selected={timeFromField.value}
                            onChange={handleTimeFrom}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={60}
                            timeCaption="Time"
                            dateFormat="hh:mm aa"
                            timeFormat="hh:mm aa"
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        </InputGroup>
                        <span style={{ color: "red" }}>
                          {errors?.timeFrom?.message}
                        </span>
                      </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-6">
                      <Label className="col-lg-12 col-form-label">
                        Time To (Hours)
                      </Label>
                      <Col lg="12">
                        <InputGroup
                          className="date"
                          id="dt-minimum"
                          data-target-input="nearest"
                        >
                          <DatePicker
                            className="form-control datetimepicker-input digits"
                            selected={timeToField.value}
                            onChange={handleTimeTo}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={60}
                            timeCaption="Time"
                            dateFormat="hh:mm aa"
                            timeFormat="hh:mm aa"
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        </InputGroup>
                        <span style={{ color: "red" }}>
                          {errors?.timeTo?.message}
                        </span>
                      </Col>
                    </FormGroup>
                  </>
                ) : null}
              </Row>
              <Row style={{ display: "flex", justifyContent: "center" }}>
                {/* <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Package Amount
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      {...register("packageValue", {
                        required: {
                          value: true,
                          message: "Package Value is required",
                        },
                        onChange: (e) => {
                          setValue(
                            "packageValue",
                            e.target.value.replace(/[^0-9.]/g, "")
                          );
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.packageValue?.message}
                    </span>
                  </Col>
                </FormGroup> */}
                {/* <FormGroup className="col-lg-12">
                <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                    <Input
                        id="IsNightfareTimeSlot"
                        type="checkbox"
                        checked={isNightfareTimeSlotField.value}
                        onChange={(value) => isNightfareTimeSlotField.onChange(value)}
                    />
                    <Label className="mb-0" for="IsNightfareTimeSlot" >Night Fare</Label>
                </div>
            </FormGroup> */}
                
              </Row>
              <Row style={{ display: "flex", justifyContent: "flex-start" }}>
                {/* <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Package Hours
                  </Label>
                  <Col lg="12">
                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                  <DatePicker
                                    className="form-control datetimepicker-input digits"
                                    selected={pkgTimeInMinField.value}
                                    onChange={handlePkgTimeInMinDate}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={60}
                                    timeCaption="Time"
                                    dateFormat="H:mm"
                                    timeFormat="H:mm"
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                />
                            </InputGroup>
                            <span style={{ color: "red" }}>{errors?.pkgTimeInMin?.message}</span>
                        </Col>
                    </FormGroup> */}
                {/* <FormGroup className="col-lg-6">
                        <Label className="col-lg-12 col-form-label">Extra Time Charge</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                pattern="[0-9.]+"
                                {...register("addnlTimeCharge", {
                                    required: {
                                        value: true,
                                        message: "Extra Time Charge is required",
                                    },
                                    onChange: (e) => {
                                        setValue("addnlTimeCharge", e.target.value.replace(/[^0-9.]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.addnlTimeCharge?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-6">
                        <Label className="col-lg-12 col-form-label">Extra Time Block (in hours)</Label>
                        <Col lg="12">
                            <DatePicker
                                className="form-control datetimepicker-input digits"
                                selected={addnlTimeChargeBlockInMinField.value}
                                onChange={handleAddnlTimeChargeBlockInMin}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={60}
                                timeCaption="Time"
                                dateFormat="H:mm"
                                timeFormat="H:mm"
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                            />
                            <span style={{ color: "red" }}>{errors?.addnlTimeChargeBlockInMin?.message}</span>
                        </Col>
                    </FormGroup> */}
              </Row>
              <Row style={{ display: "flex", justifyContent: "flex-start" }}>
                {/* <FormGroup className="col-lg-6" style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                            <Input id="IsTaxInclusive" type="checkbox" checked={isTaxInclusiveField.value}
                                onChange={(value) => isTaxInclusiveField.onChange(value)} />
                            <Label className="mb-0" for="IsTaxInclusive">Including Tax</Label>
                        </div>
                    </FormGroup> */}
                <FormGroup
                  className="col-lg-6"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className={
                      mix_background_layout == "dark-only"
                        ? "checkbox-dark p-0"
                        : "checkbox p-0"
                    }
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Input
                      id="IsTimeBased"
                      type="checkbox"
                      checked={isTimeBasedField.value}
                      onChange={(value) => isTimeBasedField.onChange(value)}
                    />
                    <Label className="mb-0" for="IsTimeBased">
                      Time Based
                    </Label>
                  </div>
                </FormGroup>
              </Row>
              {/* <Row style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ color: "#2F3293", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
            </Row> */}
                {/* {isAdvanced ? <Row style={{ display: "flex", justifyContent: "center" }}>
                
                

            </Row> : null} */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        {packageRateObj?.id ? "Update" : "Create"}
                    </button>
                </div>
                    </Form>
                    
                    {/* Scheduled Changes Section */}
                    {packageRateObj?.id && (
                        <PackageRateScheduleTable 
                            packageRateData={packageRateObj} 
                            refreshSchedules={refreshSchedules}
                            onEditSchedule={handleEditSchedule}
                        />
                    )}
                </Box>
        </Box>
        </Drawer>

    </>
    )
}

export default EditPackageRateForm